var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoBaggageCarryon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3V5.13396L14 7.13396V3L10 3V11.134L5.00002 16.134V14C5.00002 12.8954 5.89546 12 7.00002 12H8.00002V3C8.00002 1.89543 8.89546 1 10 1H14C15.1046 1 16 1.89543 16 3ZM16 10.8176L23.3174 3.5002L21.8924 2.0752L2.09241 21.8752L3.51741 23.3002L5.49753 21.3201C5.86406 21.7369 6.40132 22 7.00002 22C7.00002 22.5523 7.44774 23 8.00002 23C8.55231 23 9.00002 22.5523 9.00002 22H15C15 22.5523 15.4477 23 16 23C16.5523 23 17 22.5523 17 22C18.1046 22 19 21.1046 19 20V14C19 12.8954 18.1046 12 17 12H16V10.8176ZM9.8176 17L10.8176 16H16V17H9.8176Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBaggageCarryon);
export default __webpack_public_path__ + "static/media/no_baggage_carryon.c3a93c74c3ff683b3ab3e13a9a50f9fb.svg";
export { ForwardRef as ReactComponent };